export default "{{ displayDate }}";